module.exports = __webpack_public_path__ + "img/DerAufprall14.30bf8cf2.jpg";